/* eslint-disable */
import React from 'react';
import ReactModal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import closeSvg from 'src/assets/close.svg';

// Icons
import { ReactComponent as ManagerBlue } from 'src/assets/manager-blue-signup.svg';
import { ReactComponent as ManagerWhite } from 'src/assets/manager-white-signup.svg';
import { ReactComponent as UserBlue } from 'src/assets/user-blue-signup.svg';
import { ReactComponent as UserWhite } from 'src/assets/user-white-signup.svg';

import { ModalContainer, ModalHeader, CloseIcon, CardWrapper, RoleCard, IconWrapper, Subtitle, Title } from './styles';

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SignUpRoleModal: React.FC<Props> = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const closeModal = () => setIsOpen(false);

  const goToUserSignup = () => {
    closeModal();
    navigate('/sign-up');
  };

  const goToManagerSignup = () => {
    closeModal();
    navigate('/sign-up-manager');
  };

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={closeModal}
      style={{
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.6)',
        },
        content: {
          width: '640px',
          height: '450px',
          margin: 'auto',
          borderRadius: '24px',
          padding: '2px 32px',
          background: '#F3F4F8',
        },
      }}
    >
      <ModalContainer>
        <ModalHeader>
          <CloseIcon src={closeSvg} onClick={closeModal} />
        </ModalHeader>

        <CardWrapper>
          {/* User */}
          <RoleCard onClick={goToUserSignup}>
            <IconWrapper>
              <UserBlue className="icon default" />
              <UserWhite className="icon hover" />
            </IconWrapper>
            <Subtitle>Sign up as</Subtitle>
            <Title>User</Title>
          </RoleCard>
          {/* Manager */}
          <RoleCard onClick={goToManagerSignup}>
            <IconWrapper>
              <ManagerBlue className="icon default" />
              <ManagerWhite className="icon hover" />
            </IconWrapper>
            <Subtitle>Sign up as</Subtitle>
            <Title>Manager</Title>
          </RoleCard>
        </CardWrapper>
      </ModalContainer>
    </ReactModal>
  );
};
